import * as React from 'react';
import { ILayoutProps } from './ILayout';
import Header from './Header/Header';

const Layout = (props: ILayoutProps) => {
    return (
        <>
            <Header />
            <main>{props.children}</main>
        </>
    );
};
export default Layout;
